import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BadgeCheck, QrCode, ScanLine, ShieldCheck, Sprout, Tractor } from "lucide-react";
import { useApp } from "../context/AppContext";
import Reveal from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DEMO_CERT = "DO-2026-SEED01";

export default function HomeWatheeq() {
  const { t, lang } = useApp();
  const [stats, setStats] = useState(null);
  const [cert, setCert] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/stats`).then((r) => setStats(r.data)).catch(() => setStats({}));
    axios.get(`${API}/certificates/verify/${DEMO_CERT}`).then((r) => setCert(r.data)).catch(() => setCert(null));
  }, []);
  const nums = [
    ["certificates", ShieldCheck, t("home.wq.certs")],
    ["farms", Tractor, t("home.wq.farms")],
    ["farmers", Sprout, t("home.wq.farmers")],
  ];
  return (
    <section className="home-wq" id="watheeq" data-testid="home-watheeq">
      <Reveal className="home-wq-cert-wrap">
        <div className="home-wq-cert glass-card" data-testid="home-wq-cert">
          <span className="wq-mark">وثيق <small>WATHEEQ</small></span>
          <div className="home-wq-cert-body">
            <img src={`${API}/certificates/${DEMO_CERT}/qr.png`} alt="QR" className="home-wq-qr" loading="lazy" width="112" height="112" />
            <dl>
              <div><dt>ID</dt><dd dir="ltr">{DEMO_CERT}</dd></div>
              <div><dt>{t("verify.variety")}</dt><dd>{cert ? cert[`variety_${lang}`] : "—"}</dd></div>
              <div><dt>{t("verify.farm")}</dt><dd>{cert?.farm_name || "—"}</dd></div>
              <div><dt>{t("verify.region")}</dt><dd>{cert ? cert[`region_${lang}`] : "—"}</dd></div>
            </dl>
          </div>
          <span className={`tour-seal ${cert?.status === "revoked" ? "revoked" : ""}`}><BadgeCheck size={13} /> {t(cert?.status === "revoked" ? "tour.status.revoked" : "tour.status.valid")}</span>
        </div>
      </Reveal>
      <div className="home-wq-side">
        <Reveal>
          <ol className="home-wq-steps" data-testid="home-wq-steps">
            <li><QrCode size={18} /><div><strong>{t("home.wq.s1")}</strong><span>{t("home.wq.s1d")}</span></div></li>
            <li><ScanLine size={18} /><div><strong>{t("home.wq.s2")}</strong><span>{t("home.wq.s2d")}</span></div></li>
            <li><ShieldCheck size={18} /><div><strong>{t("home.wq.s3")}</strong><span>{t("home.wq.s3d")}</span></div></li>
          </ol>
        </Reveal>
        <Reveal delay={120}>
          <div className="home-wq-stats" data-testid="home-wq-stats">
            {nums.map(([k, Icon, label]) => (
              <div key={k} className="home-wq-stat glass-card"><Icon size={16} /><strong>{stats ? (stats[k] ?? 0).toLocaleString("en") : "—"}</strong><span>{label}</span></div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={200}>
          <div className="home-cta-row start">
            <Link to={`/verify/${DEMO_CERT}`} className="btn-lux-gold" data-testid="home-wq-verify"><ScanLine size={16} /> {t("home.wq.verifyCta")}</Link>
            <Link to="/auth?type=farmer&mode=register&next=/provenance/dashboard" className="btn-lux-ghost" data-testid="home-wq-join"><Tractor size={16} /> {t("home.wq.joinCta")}</Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
